import {
    SET_REPORT_LIST, IS_LINK_SAVED, SET_E1_UPLOAD_TEMPLATE_EXCEL_DATA
} from './ReportListType';


const reducers = (state = [], action: any) => {
    switch (action.type) {
        case SET_REPORT_LIST:
            return {
                ...state,
                reportList: action.reportList,
            };
        case IS_LINK_SAVED:
            return {
                ...state,
                isLinkSavedFlag: action.flag,
            };
         case SET_E1_UPLOAD_TEMPLATE_EXCEL_DATA:
            return {
                ...state,
                E1UploadTemplateExcelData: action.payload,
            };
        default:
            return state;
    }
}

export {
    reducers
}